import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { useEcommerceContext } from '@blaze-cms/ecommerce-context';
import { addModifier, getCartItemsTotal } from '../helpers';
import { FLYOUT_BASKET_CLASS_NAME } from './constants';
import FlyOutBasketTotal from './FlyOutBasketTotal';
import EcommerceButton from '../EcommerceButton';
import FlyOutBasket from './FlyOutBasket';

const FlyOutBasketContainer = ({
  modifier,
  cartUrl,
  checkoutUrl,
  VariantComponent,
  checkoutButtonText,
  viewCartButtonText
}) => {
  const router = useRouter();
  const [showFlyOut, setShowFlyOut] = useState({ show: false, style: {} });
  const { cartData, isBasketEmpty } = useEcommerceContext();
  const { lineItems = [], formattedTotalWithoutShipping, formattedTotal } = cartData || {};
  const { style, show } = showFlyOut;

  const handleBasketTotalClick = (top, left) => {
    setShowFlyOut({ show: !show, style: { top, left } });
  };

  const handleButtonClick = urlToCheck => {
    if (isBasketEmpty || !urlToCheck) return;
    router.push('/Resolver', urlToCheck);
  };

  useEffect(
    () => {
      const handleRouteChange = () => {
        setShowFlyOut({ show: false });
      };

      router.events.on('routeChangeStart', handleRouteChange);

      // If the component is unmounted, unsubscribe
      // from the event with the `off` method:
      return () => {
        router.events.off('routeChangeStart', handleRouteChange);
      };
    },
    [router]
  );

  // if (error) return <>{error.message}</>; // todo: handle errors differently

  const basketClassName = addModifier(FLYOUT_BASKET_CLASS_NAME, modifier);
  const basketTotalItems = getCartItemsTotal(lineItems);
  const totalToUse = formattedTotalWithoutShipping || formattedTotal;

  return (
    <div className={basketClassName}>
      {VariantComponent && (
        <VariantComponent handleOnClick={handleBasketTotalClick} basketTotal={basketTotalItems} />
      )}
      {!VariantComponent && (
        <>
          <FlyOutBasketTotal
            handleOnClick={handleBasketTotalClick}
            quantity={basketTotalItems}
            totalPrice={totalToUse}
          />
          <EcommerceButton
            handleOnClick={() => handleButtonClick(checkoutUrl)}
            isDisabled={isBasketEmpty}
            buttonText={checkoutButtonText || 'Checkout'}
            className={FLYOUT_BASKET_CLASS_NAME}
          />
        </>
      )}

      {show && (
        <FlyOutBasket
          basketStyle={style}
          basketItems={lineItems}
          basketTotalItems={basketTotalItems}
          cartUrl={cartUrl}
          checkoutUrl={checkoutUrl}
          handleButtonClick={handleButtonClick}
          formattedTotal={totalToUse}
          handleHideFlyout={() => setShowFlyOut({ show: false })}
          checkoutButtonText={checkoutButtonText || 'Checkout'}
          viewCartButtonText={viewCartButtonText || 'View cart'}
          isBasketEmpty={isBasketEmpty}
        />
      )}
    </div>
  );
};

FlyOutBasketContainer.propTypes = {
  modifier: PropTypes.string,
  cartUrl: PropTypes.string,
  checkoutUrl: PropTypes.string,
  VariantComponent: PropTypes.any,
  checkoutButtonText: PropTypes.string,
  viewCartButtonText: PropTypes.string
};

FlyOutBasketContainer.defaultProps = {
  modifier: '',
  cartUrl: '',
  checkoutUrl: '',
  checkoutButtonText: '',
  viewCartButtonText: '',
  VariantComponent: null
};

export default FlyOutBasketContainer;
